import { useQuery } from '@tanstack/react-query';
import { getFinance } from '@/api/endpoints/finance';
import type { FinancePeriod } from '@/types/finance.types';

export const useFinance = (period: FinancePeriod) => {
  return useQuery({
    queryKey: ['finance', period],
    queryFn: () => getFinance(period),
    staleTime: 1000 * 60,
    retry: 1,
  });
};
